import '.cc{position:relative;}.ssr-plugin'
import '.iu{width:64px;}.ssr-plugin'
import '.iv{height:64px;}.ssr-plugin'
import '.e{flex-shrink:0;}.ssr-plugin'
import '.az{position:absolute;}.ssr-plugin'
import '.iw{bottom:-4px;}.ssr-plugin'
import '.d0{right:-4px;}.ssr-plugin'
import '.ej{border-radius:50%;}.ssr-plugin'
import '.ix{border:2px solid var(--palette-white);}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.iy{width:32px;}.ssr-plugin'
import '.iz{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="cc iu iv e"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="az iw d0 ej ix c iy iz"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
